module.exports = __webpack_public_path__ + "img/blog-details-6.b113a957.jpg";